//视频client对象
import {isEmpty} from "../utils";

let Client = null
//屏幕分享client对象
let shareClient = null
//本地视频流对象
let localStream = null
//本地屏幕流对象
let localShareStream = null
let isJoin = false
window.localPub = false
window.localSharePub = false
//sdkAppId
const sdkAppId = 1400390096

/**
 * 创建Client视频流客户端对象
 * @param userId  医生id
 * @param userSig  接口返回签名
 */
export function createClient(userId, userSig) {
  // 初始化
  Client = TRTC.createClient({
    mode: 'videoCall',
    userId: userId,
    userSig: userSig,
    sdkAppId: sdkAppId,
  });
  Client.on('stream-added', streamAdd);
  Client.on('stream-subscribed', streamSub);
  Client.on('stream-removed', streamRemove);
  console.log('Client创建成功')
  bus.$emit('tecentInitSuccess')
}


/**
 * 创建shareClient屏幕分享客户端对象
 * @param shareId  分享id
 * @param userSig  接口返回签名
 */

/*export function createShareClient(shareId, userSig) {
  // 初始化
  shareClient = TRTC.createClient({
    mode: 'videoCall',
    userId: shareId,
    userSig: userSig,
    sdkAppId: sdkAppId
  });
  console.log('shareClient创建成功')
  // 指明该 shareClient 默认不接收任何远端流 （它只负责发送屏幕分享流）
  shareClient.setDefaultMuteRemoteStreams(true);
}*/

export function joinRoom(roomId, userId) {
  Client.join({roomId}).then(() => {
    isJoin = true
    console.log('进入房间成功');
    createLocalStream(userId);
    // createShareStream(userId);
  }).catch(error => {
    console.error('进房失败 ' + error);
  });
}

/*export function shareIdJoinRoom(roomId, userId) {
    Client.join({roomId}).then(() => {
        console.log('shareId进入房间成功');
        createShareStream(userId);
    }).catch(error => {
        console.error('shareId进房失败 ' + error);
    });
}*/

//创建本地视频流
export function createLocalStream(userId) {
  localStream = TRTC.createStream({
    userId: userId,
    audio: true,
    video: true,
    echoCancellation: true,
    noiseSuppression: true,
    autoGainControl: true,
  });
  localStream.on('player-state-changed', localStreamChange)
  console.log('创建本地视频流对象');
  console.log(localStream);
  localStream.initialize().catch(error => {
    console.error('初始化本地流失败 ' + error);
  }).then(() => {
    console.log('初始化本地流成功');
    bus.$emit('onCreateLocalStrem', localStream.mediaStream_)
    pushLocal(localStream);
  });

}

/**
 * 创建屏幕分享流
 * */
export function createShareStream(userId) {
  localShareStream = TRTC.createStream({userId: userId, audio: false, screen: true});
  // localShareStream = TRTC.createStream({userId: userId, screenAudio: true, screen: true});
  localShareStream.on('screen-sharing-stopped', unPubLocalShare)
  localShareStream.on('player-state-changed', localShareStreamChange)
  console.log('创建本地桌面流对象');
  console.log(localShareStream);
  localShareStream.initialize().catch(error => {
    console.error('初始化本地桌面流失败 ' + error);
    bus.$emit('onUnPublishShare')
  }).then(() => {
    console.log('初始化本地桌面流成功');
    pushShareStream(localShareStream);
  });
}

//发布本地视频
async function pushLocal(localStream) {
  await checkPubStatus()
  setTimeout(() => {
    Client.publish(localStream)
      .catch(error => {
        console.error('本地流发布失败 ' + error);
      })
      .then(() => {
        localPub = true
        console.log('本地流发布成功');
        let streamId = getStreamId(localStream)
        bus.$emit('onPublishLocalStream', localStream.mediaStream_, streamId)
      });
  }, 5000)
}

//发布本地桌面流
async function pushShareStream(shareStream) {
  await checkPubStatus()
  setTimeout(() => {
    Client.publish(shareStream)
      .catch(error => {
        console.error('桌面流发布失败 ' + error);
      })
      .then(() => {
        localSharePub = true
        let streamId = getStreamId(shareStream)
        bus.$emit('onPublishShareStream', shareStream.mediaStream_, streamId)
        console.log('桌面流发布成功');
      });
  }, 5000)

}

//订阅远端流对象
function streamAdd(info) {
  let remoteStream = info.stream;
  //订阅远端流
  console.log('远端流增加: ' + remoteStream.getId());
  Client.subscribe(remoteStream);
}

//处理远端流
function streamSub(info) {
  var remoteStream = info.stream;
  console.log('远端流订阅成功：' + remoteStream.getId());
  // 播放远端流
  console.log('订阅远端流', remoteStream);
  let streamId = getStreamId(remoteStream)
  let userId = remoteStream.getUserId()
  bus.$emit('onReciveRemoteStrem', remoteStream.mediaStream_, streamId, userId)
}

//远端流取消发布
function streamRemove(info) {
  var remoteStream = info.stream;
  let streamId = getStreamId(remoteStream)
  let userId = remoteStream.getUserId()
  console.log('远端流取消发布', userId)
  bus.$emit('onRemoteStreamRemove', remoteStream.mediaStream_, streamId, userId)
}

async function unPubLocalShare(stream) {
  console.log('取消分享')
  await unPublishLocalStream(localShareStream)
  bus.$emit('onUnPublishShare')
}

//本地停止发布stream
export function unPublishLocalStream(stream) {
  return new Promise(resolve => {
    Client.unpublish(stream).then(() => {
      // 关闭屏幕分享流
      stream.close();
      localPub = false
      localSharePub = false
      console.log('本地停止推流')
      resolve()
    });
  })

}

//退出房间
export function leaveRoom() {
  Client.leave().catch(error => {
    console.error('退房失败', error)
  }).then(() => {
    localStream && localStream.close()
    localPub = false
    localSharePub = false
    // 退房成功，可再次调用client.join重新进房开启新的通话。
  });
}


//获取stream所属userId
function getStreamId(stream) {
  console.log("stream", stream)
  console.log('stream userId', stream.getUserId())
  console.log('stream id', stream.getId())
  return stream.getId()

}

function localStreamChange(event) {
  Log('localStream change')
  console.log(event.type)
  console.log(event.state)
  console.log(event.reason)
}

function localShareStreamChange(event) {
  Log('localShareStream change')
  console.log(event.type)
  console.log(event.state)
  console.log(event.reason)
}

async function checkPubStatus() {
  Log('发布状态', localPub, localSharePub)
  if (localPub) {
    Log('已发布本地视频流')
    await unPublishLocalStream(localStream)
  } else if (localSharePub) {
    Log('已发布本地桌面流')
    await unPublishLocalStream(localShareStream)
  }
}
